export default {
  state: {
    models: [
      {
        type: 'bags', // тип изделия
        model: 'bag', // УНИКАЛЬНОЕ, модель
        title: 'Пакет ПВД', // заголовок
        gender: '', // пол: 'male', 'female', 'unisex', 'children'
        minOrderAmount: 3000, // минимальная сумма заказа
        colors: [ 'white', 'turquoise', 'burgundy', 'cyan', 'blue-metallic', 'yellow', 'green', 'gold',
          'brown', 'red', 'orange', 'pink', 'lettuce', 'light-beige', 'silver', 'blue',
          'dark-green', 'dark-blue', 'purple', 'black' ], // доступные цвета
        defaultColor: 'white',
        image: `${process.env.BASE_URL}img/bags/paket-pvd/white.jpg`,
        slides: [
          {
            color: 'white',
            image: `${process.env.BASE_URL}img/bags/paket-pvd/white.jpg`,
            thumb: `${process.env.BASE_URL}img/bags/paket-pvd/white-100x100.jpg`,
          },
        ],
        sizes: [ // доступные размеры
          'bag20x30',
          'bag30x40',
          'bag40x50',
          'bag50x60',
          'bag60x70',
        ],
        priceList: [ // from - кол-во "от", to кол-во "до" (включительно), price - цена за шт
          {from: 0, price: 0 },
        ]
      },
    ]
  }
}